// src/pages/PainelCliente/CadastrarOperacao.js
import { useEffect, useState, useCallback } from "react";
import axios from "../../axiosConfig";
import { useNavigate } from "react-router-dom";
import "./CadastrarOperacao.css";
import { NumericFormat } from "react-number-format";


const LIMITE_DIAS_OPERACAO_PONTOS = 60;

function getApiErrorMessage(err, fallback = "Erro ao processar solicitação.") {
  return (
    err.response?.data?.mensagem ||
    err.response?.data?.error ||
    err.response?.data?.erro ||
    (typeof err.response?.data === "string" ? err.response.data : "") ||
    err.message ||
    fallback
  );
}

function validarDataOperacaoRecente(dataOperacao, limiteDias) {
  const data = String(dataOperacao || "").slice(0, 10);
  if (!data || !/^\d{4}-\d{2}-\d{2}$/.test(data)) return false;

  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  const dataRef = new Date(`${data}T00:00:00`);
  if (Number.isNaN(dataRef.getTime())) return false;

  const limite = new Date(hoje);
  limite.setDate(limite.getDate() - limiteDias);

  return dataRef >= limite && dataRef <= hoje;
}

function CadastrarOperacao() {
  const usuario = JSON.parse(localStorage.getItem("usuario"));
  const navigate = useNavigate();

  const [mostrarModalEmpresa, setMostrarModalEmpresa] = useState(false);
  const [empresaVerificada, setEmpresaVerificada] = useState(false);

  const [mensagemNumeroPedido, setMensagemNumeroPedido] = useState("");
  const [statusPedido, setStatusPedido] = useState(""); // "aprovado" | "erro" | "aviso"
  const [camposBloqueados, setCamposBloqueados] = useState(false);
 

  const [formData, setFormData] = useState({
    data_operacao: "",
    valor: "",
    numero_parcelas: "",
    numero_pedido: "",
    nome_pagador: "",
    observacoes: "",
  });

  const [mensagem, setMensagem] = useState("");
  const [dadosEnviados, setDadosEnviados] = useState(null);

  // Busca valor do ponto e verifica empresa
  useEffect(() => {
    

    const verificarEmpresa = async () => {
      try {
        const clienteRes = await axios.get(`/clientes/${usuario.id}`);
        const cnpjEmpresa = clienteRes.data?.cnpj_empresa;
        if (!cnpjEmpresa) { setMostrarModalEmpresa(true); return; }

        const normalizar = (cnpj) => String(cnpj).replace(/\D/g, "");
        const empresaRes = await axios.get(`/empresas/cnpj/${normalizar(cnpjEmpresa)}`);
        const empresa = empresaRes.data;

        if (!empresa || Number(empresa.ativa) !== 1) {
          setMostrarModalEmpresa(true);
        } else {
          setEmpresaVerificada(true);
        }
      } catch (err) {
        console.error("Erro ao verificar status da empresa:", err);
        setMostrarModalEmpresa(true);
      }
    };

    verificarEmpresa();
  }, [usuario.id]);

  // Calcula pontos estimados
  const calcularPontosEstimados = useCallback(() => {
  const valor = Number(formData.valor) || 0;
  const parcelas = parseInt(formData.numero_parcelas, 10) || 0;

  if (valor <= 0) return 0;

  return parcelas >= 3
    ? Math.floor(valor)
    : Math.floor(valor * 0.2);
}, [formData.valor, formData.numero_parcelas]);

  const pontosEstimados = calcularPontosEstimados();

  const buscarDadosTikpag = async (numero) => {
    setMensagemNumeroPedido("");
    setStatusPedido("");
    setCamposBloqueados(false);

    const numeroLimpo = parseInt(numero.replace(/\D/g, ""), 10);
    if (isNaN(numeroLimpo)) {
      setMensagemNumeroPedido("Número inválido. Digite apenas números.");
      setStatusPedido("erro");
      return;
    }

    try {
      const resposta = await axios.get(
        `/operacoes/consultar-pedido/${numeroLimpo}`
      );
      const pedido = resposta.data;
      const dataOperacaoTikpag = pedido.data_criacao?.split("T")[0] || "";

      switch (pedido.status?.toLowerCase()) {
        case "aprovado":

        if (!validarDataOperacaoRecente(dataOperacaoTikpag, LIMITE_DIAS_OPERACAO_PONTOS)) {
            setFormData((prev) => ({
              ...prev,
              numero_pedido: numero,
              data_operacao: dataOperacaoTikpag,
              valor: pedido.valor || "",
              numero_parcelas: pedido.parcelas || "",
              nome_pagador: pedido.cliente || "",
              observacoes: "",
            }));
            setCamposBloqueados(true);
            setMensagemNumeroPedido(
              `Pedido aprovado na Tikpag, porém fora do prazo de cadastro no Tikpontos. O cadastro pelo cliente é permitido apenas para operações realizadas nos últimos ${LIMITE_DIAS_OPERACAO_PONTOS} dias. Em caso de dúvidas, entre em contato com o administrador.`
            );
            setStatusPedido("erro");
            return;
          }


          setFormData({
            numero_pedido: numero,
            data_operacao: dataOperacaoTikpag,
            valor: pedido.valor || "",
            numero_parcelas: pedido.parcelas || "",
            nome_pagador: pedido.cliente || "",
            observacoes: "",
          });
          setCamposBloqueados(true);
          setMensagemNumeroPedido("Pedido aprovado — dados preenchidos automaticamente.");
          setStatusPedido("aprovado");
          break;
        case "negado":
          setMensagemNumeroPedido("Este pedido está com status Negado. Verifique no seu painel.");
          setStatusPedido("erro");
          break;
        case "cancelado":
          setMensagemNumeroPedido("Este pedido foi Cancelado. Verifique no seu painel.");
          setStatusPedido("erro");
          break;
        case "aguardando autenticação do cliente":
        case "aguardando autenticacao do cliente":
          setMensagemNumeroPedido("Este pedido ainda não foi finalizado pelo cliente. Aguarde a aprovação.");
          setStatusPedido("aviso");
          break;
        default:
          setMensagemNumeroPedido("Status desconhecido ou pedido inválido.");
          setStatusPedido("aviso");
      }
    } catch (erro) {
      console.error("Erro ao consultar Tikpag:", erro);
      const status = erro.response?.status;

          if (status === 404) {
            setMensagemNumeroPedido(
              "Pedido não encontrado na Tikpag. Confira o número digitado e tente novamente."
            );
          } else if (status === 401) {
          setMensagemNumeroPedido(
            "Sua sessão expirou. Entre novamente no Tikpontos e tente outra vez."
          );
        } else if (status === 403) {
          setMensagemNumeroPedido(
            erro.response?.data?.error ||
              "Este pedido não pertence à imobiliária vinculada ao seu cadastro."
          );
        } else {
            setMensagemNumeroPedido(
              "Não foi possível consultar os dados deste pedido no momento. Tente novamente em alguns instantes."
            );
          }
      setStatusPedido("erro");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (mostrarModalEmpresa) {
      setMensagem("Sua empresa não está participando do programa no momento.");
      return;
    }

    
    if (!validarDataOperacaoRecente(formData.data_operacao, LIMITE_DIAS_OPERACAO_PONTOS)) {
      setMensagem(
        `Esta operação está fora do prazo de cadastro. O Tikpontos permite que clientes cadastrem apenas operações realizadas nos últimos ${LIMITE_DIAS_OPERACAO_PONTOS} dias. Em caso de dúvidas, solicite análise ao administrador.`
      );
      return;
    }



    try {
      await axios.post("/operacoes", { usuario_id: usuario.id, ...formData });
      setMensagem("✅ Operação cadastrada com sucesso!");
      setDadosEnviados(formData);
      setFormData({
        data_operacao: "", valor: "", numero_parcelas: "",
        numero_pedido: "", nome_pagador: "", observacoes: "",
      });
      setCamposBloqueados(false);
      setStatusPedido("");
      setMensagemNumeroPedido("");
    } catch (err) {
      console.error("Erro ao cadastrar operação:", err);
      setMensagem(`⚠️ ${getApiErrorMessage(err, "Erro ao cadastrar operação.")}`);
    }
  };

  return (
    <div className="cadastrar-operacao-container">

      {/* Modal empresa inativa */}
      {mostrarModalEmpresa && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>🚫 Não é possível cadastrar operações</h3>
            <p>
              Sua empresa não está participando do programa de pontos no momento. Aguarde novos programas.
            </p>
          </div>
        </div>
      )}

      {empresaVerificada && (
        <div className="cadastrar-operacao-card">
          <div className="cadastrar-operacao-card-top" />

          <div className="cadastrar-operacao-card-body">

            {/* Header */}
            <div className="cadastrar-operacao-header">
              <h2 className="titulo">Cadastrar Operação</h2>
              <button className="btn-fechar" onClick={() => navigate("/painel-cliente")}>✕</button>
            </div>

            {/* Banner informativo */}
            <div className="info-banner">
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#1B4FD8" strokeWidth="1.5">
                <circle cx="8" cy="8" r="6"/><path d="M8 7v4M8 5.5v.01"/>
              </svg>
              Digite o número do pedido aprovado — os campos serão preenchidos automaticamente via Tikpag.
            </div>

            <form onSubmit={handleSubmit} className="form-operacao">
              <div className="form-two-col">

                {/* ── COLUNA ESQUERDA ── */}
                <div className="form-col-left">

                  {/* Número do pedido */}
                  <div className="form-field">
                    <label>Número do pedido</label>
                    <input
                      type="text"
                      name="numero_pedido"
                      placeholder="Ex: 315"
                      value={formData.numero_pedido}
                      className={statusPedido === "aprovado" ? "input-aprovado" : ""}
                      onChange={(e) => {
                        const somenteNumeros = e.target.value.replace(/\D/g, "");
                        setFormData((prev) => ({ ...prev, numero_pedido: somenteNumeros }));
                      }}
                      onBlur={async (e) => {
                        const numero = e.target.value;
                        if (numero) {
                          try {
                            const resposta = await axios.get(`/operacoes/verificar-numero/${numero}`);
                              if (resposta.data.jaExiste) {
                                setMensagemNumeroPedido(
                                  resposta.data.mensagem ||
                                    `Este pedido já foi cadastrado em ${resposta.data.data} pela empresa: ${resposta.data.empresa}.`
                                );
                                setStatusPedido("erro");
                                return;
                              }

                              buscarDadosTikpag(numero);
                          } catch (erro) {
                              console.error("Erro ao verificar número do pedido:", erro);
                              setMensagemNumeroPedido(
                                erro.response?.data?.error ||
                                  erro.response?.data?.mensagem ||
                                  "Não foi possível verificar este pedido no momento. Tente novamente em alguns instantes."
                              );
                              setStatusPedido("erro");
                            }
                        }
                      }}
                      inputMode="numeric"
                      pattern="\d*"
                      required
                    />
                    {mensagemNumeroPedido && (
                      <div className={`status-pedido ${statusPedido}`}>
                        <div className="status-dot" />
                        {mensagemNumeroPedido}
                      </div>
                    )}
                  </div>

                  {/* Data + Parcelas */}
                  <div className="form-field-row">
                    <div className="form-field">
                      <label>
                        Data da operação
                        {camposBloqueados && <span className="campo-auto">auto</span>}
                      </label>
                      <input
                        type="date"
                        name="data_operacao"
                        value={formData.data_operacao}
                        onChange={handleChange}
                        readOnly={camposBloqueados}
                        required
                      />
                    </div>
                    <div className="form-field">
                      <label>
                        Parcelas
                        {camposBloqueados && <span className="campo-auto">auto</span>}
                      </label>
                      <input
                        type="number"
                        name="numero_parcelas"
                        value={formData.numero_parcelas}
                        onChange={handleChange}
                        readOnly={camposBloqueados}
                        required
                      />
                    </div>
                  </div>

                  {/* Valor */}
                  <div className="form-field">
                    <label>
                      Valor da operação
                      {camposBloqueados && <span className="campo-auto">auto</span>}
                    </label>
                    <span className="campo-sub">Valor principal sem taxas Tikpag</span>
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      prefix="R$ "
                      decimalScale={2}
                      fixedDecimalScale
                      allowNegative={false}
                      value={formData.valor}
                      onValueChange={(val) =>
                        setFormData({ ...formData, valor: val.floatValue || 0 })
                      }
                      className="input-moeda"
                      readOnly={camposBloqueados}
                    />
                  </div>

                  {/* Nome do pagador */}
                  <div className="form-field">
                    <label>
                      Nome do pagador
                      {camposBloqueados && <span className="campo-auto">auto</span>}
                    </label>
                    <input
                      type="text"
                      name="nome_pagador"
                      value={formData.nome_pagador}
                      onChange={handleChange}
                      readOnly={camposBloqueados}
                    />
                  </div>

                </div>

                {/* ── COLUNA DIREITA ── */}
                <div className="form-col-right">

                  {/* Observações */}
                  <div className="form-field">
                    <label>
                      Observações
                      <span style={{ fontSize: "10px", color: "#94A3B8", fontWeight: 400 }}>(opcional)</span>
                    </label>
                    <textarea
                      name="observacoes"
                      value={formData.observacoes}
                      onChange={handleChange}
                      placeholder="Alguma informação adicional sobre esta operação..."
                      rows="5"
                    />
                  </div>

                  <div className="form-divider" />

                  {/* Pontos estimados */}
                  <div className="pts-estimados">
                    <span className="pts-estimados-label">Pontos estimados</span>
                    <span className="pts-estimados-valor">
                      {pontosEstimados > 0
                        ? pontosEstimados.toLocaleString("pt-BR")
                        : "—"}
                    </span>
                    <span className="pts-estimados-sub">
                      {pontosEstimados > 0
                        ? `Estimativa conforme regra do Tikpontos: ${formData.numero_parcelas >= 3 ? "100%" : "20%"} do valor · sujeito a aprovação`
                        : "Preencha o valor e parcelas para estimar"}
                    </span>
                  </div>

                  {/* Botão */}
                    <button type="submit" className="btn azul" disabled={statusPedido === "erro"}>
                     Cadastrar operação
                   </button>

                  {/* Mensagem de retorno */}
                  {mensagem && (
                    <p className="mensagem-envio">{mensagem}</p>
                  )}

                </div>
              </div>
            </form>

            {/* Resumo pós envio */}
            {dadosEnviados && (
              <div className="resumo-operacao">
                <h4>Resumo da operação cadastrada</h4>
                <ul>
                  <li><strong>Pedido:</strong> #{dadosEnviados.numero_pedido}</li>
                  <li><strong>Data:</strong> {dadosEnviados.data_operacao}</li>
                  <li><strong>Valor:</strong> R$ {Number(dadosEnviados.valor).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</li>
                  <li><strong>Parcelas:</strong> {dadosEnviados.numero_parcelas}x</li>
                  <li><strong>Pagador:</strong> {dadosEnviados.nome_pagador}</li>
                  {dadosEnviados.observacoes && (
                    <li><strong>Observações:</strong> {dadosEnviados.observacoes}</li>
                  )}
                </ul>
                <p className="mensagem-analise">
                  Operação enviada para análise. Assim que aprovada, os pontos serão creditados e aparecerão no seu histórico.
                </p>
              </div>
            )}

          </div>
        </div>
      )}
    </div>
  );
}

export default CadastrarOperacao;